import { createMuiTheme } from '@material-ui/core/styles';
import {
  purple,
  magenta,
  grey,
  black,
  white,
  background,
  red,
  green,
  yellow,
  alert,
} from 'globals/colors';
import { htmlFontSize, fontFamily } from 'globals/typography';
import { darken } from '@material-ui/core';

const theme = createMuiTheme({
  spacing: 8,
  palette: {
    primary: {
      main: purple.BRAND,
      light: purple.V1,
      dark: purple.BRAND,
    },
    secondary: {
      main: magenta.BRAND,
      light: magenta.V2,
      dark: magenta.V1,
    },
    error: {
      light: red.V4,
      main: alert.ERROR,
      dark: darken(alert.ERROR, 0.2),
    },
    warning: {
      light: yellow.V4,
      main: yellow.V2,
      dark: yellow.MAIN,
    },
    success: {
      light: green.V4,
      main: green.V1,
      dark: green.MAIN,
    },
    info: {
      light: purple.V4,
      main: purple.V2,
      dark: purple.BRAND,
    },
    grey: {
      100: grey.V5,
      200: grey.V4,
      300: grey.V3,
      400: grey.V2,
      500: grey.V1,
      600: grey.DARK,
      700: grey.DARK,
      800: grey.DARK,
      900: grey.DARK,
      A100: grey.A100,
      A200: grey.A200,
    },
    common: {
      black,
      white,
    },
    background: {
      paper: white,
      default: background,
    },
  },
  typography: {
    fontSize: htmlFontSize,
    htmlFontSize,
    fontFamily,
    h1: {
      fontFamily,
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 32,
      lineHeight: 1.4,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily,
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 26,
      lineHeight: 1.4,
    },
    h3: {
      fontFamily,
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 22,
      lineHeight: 1.4,
    },
    h4: {
      fontFamily,
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 18,
      lineHeight: 1.4,
    },
    subtitle1: {
      fontFamily,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: 18,
      lineHeight: 1.4,
      letterSpacing: '-0.02em',
    },
    subtitle2: {
      fontFamily,
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 18,
      lineHeight: 1.4,
    },
    caption: {
      fontFamily,
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: 12,
      lineHeight: 2.17,
      letterSpacing: '0.02em',
      textTransform: 'uppercase',
    },
    body1: {
      fontFamily,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: 1.4,
    },
    body2: {
      fontFamily,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: 1.5,
      letterSpacing: `0.01em`,
    },
    button: {
      fontFamily,
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 16,
      lineHeight: 1.625,
      letterSpacing: `0.005em`,
      textTransform: 'capitalize',
    },
  },
});

theme.typography.pxToRem = (size): string => `${size / htmlFontSize}rem`;

export default theme;
